module.exports = __webpack_public_path__ + "static/media/wandaIcon.ad869f18.svg";